import {
  StrapiActionTypes,
  StrapiItem,
  AddRequestAction,
  AddSuccessAction,
  AddFailureAction,
  UpdateRequestAction,
  UpdateSuccessAction,
  UpdateFailureAction,
  DeleteRequestAction,
  DeleteSuccessAction,
  DeleteFailureAction,
} from '../../types/strapiMyTasks';

export const addData5SCard = (modelName: string, data: any): AddRequestAction => ({
  type: StrapiActionTypes.ADD_REQUEST_MYTASKS,
  payload: {
    modelName,
    data,
  },
});

export const addData5SCardSuccess = (modelName: string, data: StrapiItem): AddSuccessAction => ({
  type: StrapiActionTypes.ADD_SUCCESS_MYTASKS,
  payload: {
    modelName,
    data,
  },
});

export const addData5SCardFailure = (modelName: string, error: string): AddFailureAction => ({
  type: StrapiActionTypes.ADD_FAILURE_MYTASKS,
  payload: {
    modelName,
    error,
  },
});

export const updateData5SCard = (modelName: string, documentId: string, data: any): UpdateRequestAction => ({
  type: StrapiActionTypes.UPDATE_REQUEST_MYTASKS,
  payload: {
    modelName,
    documentId,
    data,
  },
});

export const updateData5SCardSuccess = (modelName: string, data: StrapiItem): UpdateSuccessAction => ({
  type: StrapiActionTypes.UPDATE_SUCCESS_MYTASKS,
  payload: {
    modelName,
    data,
  },
});

export const updateData5SCardFailure = (modelName: string, error: string): UpdateFailureAction => ({
  type: StrapiActionTypes.UPDATE_FAILURE_MYTASKS,
  payload: {
    modelName,
    error,
  },
});

export const deleteData5SCard = (modelName: string, documentId: string): DeleteRequestAction => ({
  type: StrapiActionTypes.DELETE_REQUEST_MYTASKS,
  payload: {
    modelName,
    documentId,
  },
});

export const deleteData5SCardSuccess = (modelName: string, documentId: string): DeleteSuccessAction => ({
  type: StrapiActionTypes.DELETE_SUCCESS_MYTASKS,
  payload: {
    modelName,
    documentId,
  },
});

export const deleteData5SCardFailure = (modelName: string, error: string): DeleteFailureAction => ({
  type: StrapiActionTypes.DELETE_FAILURE_MYTASKS,
  payload: {
    modelName,
    error,
  },
});
